<template>
      <div class="grid p-fluid">
            <loading :active="isLoadingModel" :can-cancel="true" color="#173EA3" :is-full-page="fullPage"></loading>
            <div class="col-12 md:col-12">
                  <section class="gps_header_container">
                        <!-- <div class="col-12 md:col-12"> -->
                        <div class="grid formgrid">
                              <div class="col-12 md:col-2">
                                    <span class="p-input-icon-left">
                                          <InputText type="text" placeholder="Search By Vehicle" v-model="reg_number"
                                                v-on:change="get_dashboard_vehicle_list(2)" />
                                          <i class="pi pi-search" />
                                    </span>
                              </div>
                              <div class="field col-12 md:col-2">
                                    <span class="p-float-label">
                                          <Calendar v-model="vehicle_from_date" dateFormat="dd-mm-yy" selectionMode="range"
                                                :manualInput="false" :numberOfMonths="2" :showTime="false" hourFormat="12" />
                                          <label>Date</label>
                                    </span>
                              </div>
                              <div class="field col-12 md:col-2">
                                    <span class="p-float-label">
                                          <MultiSelect id="User" filter display="chip" v-model="vehicle_dropdownItem"
                                                :options="vehicle_dropdownItems" optionLabel="name" :maxSelectedLabels="2">
                                          </MultiSelect>
                                          <label>Vehicle Type</label>
                                    </span>
                              </div>
                              <div class="field col-12 md:col-2">
                                    <span class="p-float-label">
                                          <MultiSelect id="status" filter v-model="routeitem_multiselect" display="chip"
                                                :options="routeitems" :value="routeitems.value" optionLabel="name"
                                                required="true" :maxSelectedLabels="2"></MultiSelect>
                                          <label>Select Route</label>
                                    </span>
                              </div>
                              <div class="field col-12 md:col-2" v-if="user_key && client_group_ids">
                                    <span class="p-float-label">
                                          <MultiSelect id="state" filter display="chip" v-model="client_id_search"
                                                :options="client_id_dropdown" optionLabel="name" @change="route_list"
                                                :maxSelectedLabels="2" :optionValue="value"></MultiSelect>
                                          <label for="client">Select Client</label>
                                    </span>
                              </div>
                              <div class="field col-2 md:col-2" v-if="showFirstFilter">
                                    <span class="p-float-label">
                                          <MultiSelect id="User" filter v-model="district_dropdownItem"
                                                :options="district_dropdownItems" optionLabel="name" @change="getBlockData"
                                                display="chip">
                                          </MultiSelect>
                                          <label for="complaint_status">District</label>
                                    </span>
                              </div>
                              <div class="field col-2 md:col-2" v-if="showFirstFilter">
                                    <span class="p-float-label">
                                          <MultiSelect id="User" filter v-model="block_dropdownItem"
                                                :options="block_dropdownItems" optionLabel="name" display="chip"
                                                :loading="set_loading">
                                          </MultiSelect>
                                          <label for="complaint_status">Block</label>
                                    </span>
                              </div>
                              <div class="field col-2 md:col-2" v-if="showFirstFilter">
                                    <MultiSelect v-model="village_dropdownItem" :options="village_dropdownItems"
                                          optionLabel="name" filter display="chip" @filter="get_village"
                                          @change="get_ward_master" placeholder="Village">
                                    </MultiSelect>
                              </div>
                              <div class="field col-2 md:col-2" v-if="showFirstFilter">
                                    <MultiSelect v-model="ward_dropdownItem" :options="ward_dropdownItems" optionLabel="name"
                                          filter display="chip" placeholder="Select Ward">
                                    </MultiSelect>
                              </div>
                              <div class="field col-12 md:col-2">
                                    <Button icon="pi pi-search" v-tooltip.bottom="'Search'" severity="success"
                                          @click="get_dashboard_vehicle_list(2)" />&nbsp;
                                    <Button icon="pi pi-refresh" class="p-button-danger" @click="reset" severity="success"/>
                                    <button v-if="!showFirstFilter" style="color: #22C55E; background: none; border: none" 
                                          @click="show_filter()">
                                          more ...
                                    </button>
                              </div>
                        </div>
                        <!-- <hr style="box-shadow: 1px 0px 5px black;"> -->
                        <!-- </div> -->
                  </section>
                  <br />
                  <div class="grid">
                        <div class="col-12 md:col-3" style="overflow: auto; height: 500px; box-shadow: 3px 0 5px -2px #888"
                              v-if="vehicle_data.length == 0">
                              <b>Record Not Found</b>
                        </div>
                        <div class="col-12 md:col-3" style="
            overflow: auto;
            height: 500px;
            background-color: #f6f6f6;
            box-shadow: 5px 0 5px -2px #888;
          " v-else>
                              <Button label="Vehicle Visit Report" icon="pi pi-car" class="mr-2 mb-2" severity="success"
                                    @click="exportCSV2"></Button>
                              <div style="text-align: right">
                                    <b>Total :{{ vehicle_data.length }}</b>
                              </div>
                              <hr />

                              <div v-for="(data, key) in vehicle_data" :key="key" class="card p-fluid"
                                    :class="{ selected: key === selectedIndex }"
                                    v-on:click="get_select_vehicle_details(data, 1, key)">
                                    <div class="grid formgrid">
                                          <div class="col-12 md:col-11">
                                                <b style="color: black"><u>{{ data.vehicle_number }}</u></b>
                                          </div>
                                          <div class="col-12 md:col-1">
                                                <img src="https://sharegps.blackbuck.com/f96d6cbebbcb71567abd6dbfb3532bff.svg"
                                                      class="arrow-icon" alt="right arrow" />
                                          </div>
                                    </div>
                                    <span style="font-size: 10px">{{ dateFormatDMY(data.date) }}</span><br>
                                    <span style="font-size: 12px">Routes Covered : {{ data["Routes Covered"] }}</span><br>
                                    <span style="font-size: 12px">Routes Not Covered : {{ data["Routes Not Covered"] }}</span>
                                    <hr style="border-top: 0.2px dashed black" />
                                    <div class="grid formgrid" style="font-size: 10px">
                                          <!-- <div class="col-12 md:col-4">
                                                <b>Routes</b> <br />
                                                {{ data["Routes Covered"] }}
                                          </div> -->
                                          <div class="col-12 md:col-6">
                                                <b>Distance</b> <br />
                                                {{ data["Distance Travelled (km)"] }} Km
                                          </div>
                                          <div class="col-12 md:col-6">
                                                <b>Travelled</b> <br />
                                                {{
                                                      data["Ride Duration (hrs)"]
                                                      ? data["Ride Duration (hrs)"].toFixed(2)
                                                      : 0
                                                }}
                                                hrs
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div class="col-12 md:col-3" style="height: 500px; box-shadow: 3px 0 5px -2px #888"
                              v-if="splitterpanel">
                              <div class="col-12 md:col-12">
                                    <div class="grid formgrid">
                                          <div class="col-12 md:col-8">
                                                <b style="font-size: 16px">
                                                      Trip for
                                                      <u v-if="search_vehicle_data.length > 0">{{
                                                            search_vehicle_data[0].vehicle_number
                                                      }}</u>
                                                </b>
                                          </div>
                                          <div class="col-12 md:col-4" style="text-align: right">
                                                <Button icon="pi pi-times" @click="close"
                                                      class="p-button-rounded p-button-danger p-button-text mr-1 mb-1" />
                                          </div>
                                    </div>
                              </div>
                              <div class="col-12 md:col-12" style="overflow: scroll; height: 430px">
                                    <div v-for="(data, key) in search_vehicle_data" :key="key" class="card"
                                          :class="{ selected2: key === selectedIndex2 }">
                                          <div v-on:click="selectCard(data, key)">
                                                <div class="grid formgrid">
                                                      <div class="col-12 md:col-11">
                                                            <b>{{ data.route_name }}</b>
                                                      </div>
                                                      <div class="col-12 md:col-1">
                                                            <!-- <Button type="button" icon="pi pi-map-marker"
                                                                  v-tooltip.bottom="'View Map'" text @click="view_Map(data)" /> -->
                                                            <img src="https://sharegps.blackbuck.com/f96d6cbebbcb71567abd6dbfb3532bff.svg"
                                                                  class="arrow-icon" alt="right arrow"
                                                                  @click="view_Map(data)" />
                                                      </div>
                                                </div>
                                                <span style="font-size: 10px">{{
                                                      dateFormatDMY(data.date)
                                                }}</span><br />
                                                <span style="font-size: 12px">DistanceTravelled : {{data["Distance Travelled (km)"]}} Km</span><br />
                                                <span style="font-size: 12px">Ride Duration : {{data["Ride Duration (hrs)"]}} hrs</span><br />
                                                <span style="font-size: 10px">{{ data.vehicle_type }}</span>
                                                <hr style="border-top: 0.2px dashed black" />
                                          </div>
                                          <div class="grid formgrid">
                                                <div class="col-12 md:col-4">
                                                      <Button class="p-button-outlined p-button-sm"
                                                            @click="view_home_list(3, data)" label="Total" severity="success"
                                                            text raised size="small" />
                                                </div>
                                                <div class="col-12 md:col-4">
                                                      <Button class="p-button-outlined p-button-sm"
                                                            @click="view_home_list(1, data)" label="Visited"
                                                            severity="success" text raised size="small" />
                                                </div>
                                                <div class="col-12 md:col-4">
                                                      <Button class="p-button-outlined p-button-sm"
                                                            @click="view_home_list(2, data)" label="Pending"
                                                            severity="success" text raised size="small" />
                                                </div>
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <div :class="splitterpanel ? 'col-12 md:col-6' : 'col-12 md:col-9'" style="height: 500px">
                              <div class="grid formgrid" style="font-size: 10px">
                                    <div class="col-12 md:col-12">
                                          <SelectButton v-model="selectButtonValue1" :options="selectButtonValues1"
                                                optionDisabled="constant" optionLabel="name" multiple
                                                aria-labelledby="multiple" class="custom-select-button"/>
                                    </div>
                                    <br />
                                    <div class="col-12 md:col-12">
                                          <b>Speed - </b>
                                          <InputSwitch v-model="checked" />
                                    </div>
                                    <div class="col-12 md:col-12">
                                          <Slider v-model="selectedOption" :max="car_data.length"
                                                @change="updateSelectedValue" />
                                    </div>
                                    <br />
                              </div>
                              <img v-if="list_loader === true" src="images/loader.gif" alt="Loading"
                                    style="width: 100%; height: 500px" />
                              <GoogleMap v-else-if="polyline_show && list_loader === false"
                                    api-key="AIzaSyC-8ib8PMibUDDYoj5kzRzKwcusvw3Gztc" style="width: 100%; height: 500px"
                                    :center="center" :zoom="15" :options="mapOptions">
                                    <Marker :options="{ position: center, label: 'Start Point' }">
                                    </Marker>
                                    <Marker :options="{ position: center1, label: 'End Point' }">
                                    </Marker>
                                    <Marker :options="{ position: marker, icon: 'images/red_dot.png' }"
                                          v-for="(marker, index) in speed_marker" :key="index">
                                    </Marker>
                                    <MarkerCluster>
                                          <Marker :options="{
                                                position: marker,
                                                title: 'stop',
                                                label: marker.stop_name,
                                                color: 'green',
                                                icon: marker.icon,
                                          }" v-for="(marker, index) in markers" :key="index"
                                                style="width: 5px; height: 5px">
                                          </Marker>
                                    </MarkerCluster>
                                    <Polyline :options="polypath" />
                                    <!-- <Polyline :options="live_polypath" /> -->
                                    <Marker :options="{ position: car_marker, icon: 'images/truck3.png' }"></Marker>
                              </GoogleMap>
                        </div>
                  </div>

                  <Dialog header="List" v-model:visible="home_productDialog" :breakpoints="{ '960px': '75vw' }"
                        :style="{ width: '70vw' }" :modal="true">
                        <DataTable ref="home_dt" :value="home_list" class="p-datatable-sm" :rows="10"
                              responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="sr_no"
                              :rowHover="true" showGridlines>
                              <template #header>
                                    <div
                                          class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                          <h5 class="m-0">{{ tbl_name }} Home List</h5>
                                         
                                                <Button icon="pi pi-upload" v-tooltip.bottom="'Export'" @click="exportCSV" />
                                         
                                    </div>
                                    <div style="text-align: right; font-weight: bold">
                                          <span>Total :</span>{{ home_list.length }}
                                    </div>
                              </template>
                              <template #empty> No Record found. </template>
                              <Column field="sequence_number" header="Sequence No." sortable style="min-width: 3rem">
                                    <template #body="{ data }">
                                          <span>{{ data.sequence_number }}</span>
                                    </template>
                              </Column>
                              <Column field="stop_name" header="Stop Name" sortable style="min-width: 15rem">
                                    <template #body="{ data }">
                                          <span>{{ data.stop_name }}</span>
                                    </template>
                              </Column>
                              <Column field="visit" header="Status" sortable>
                                    <template #body="{ data }">
                                          <span v-if="data.visit == 'visited' || data.visit == 'Visited'"
                                                style="color: green">{{ data.visit }}</span>
                                          <span v-else style="color: red">{{ data.visit }}</span>
                                    </template>
                              </Column>
                              <Column field="visit_time" header="Visit Time" sortable>
                                    <template #body="{ data }">
                                          <span>{{ data.visit_time }}</span>
                                    </template>
                              </Column>
                              <Column field="distance" header="Distance Mismatch(m)" sortable>
                                    <template #body="{ data }">
                                          <span style="color: green" v-if="data.distance < 50">{{ data.distance }} m</span>
                                          <span style="color: red" v-else>{{ data.distance }} m</span>
                                    </template>
                              </Column>
                        </DataTable>
                  </Dialog>
            </div>
      </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import GoogleMapComponent from "../components/GoogleMap";
import JsonExcel from "vue-json-excel";
import {
      GoogleMap,
      Marker,
      MarkerCluster,
      InfoWindow,
      Polyline,
} from "vue3-google-map";
import apis from "@/apis";
export default {
      name: "SbmUiGps",
      data() {
            return {
                  total_distance:"0",
                  total_time:"0",
                  car_data: [],
                  car_marker: {},
                  selectedOption: null,
                  mapOptions: {
                        styles: [
                              {
                                    featureType: "poi",
                                    elementType: "labels.text",
                                    stylers: [
                                          {
                                                visibility: "off",
                                          },
                                    ],
                              },
                              {
                                    featureType: "poi.business",
                                    stylers: [
                                          {
                                                visibility: "off",
                                          },
                                    ],
                              },
                              {
                                    featureType: "road",
                                    elementType: "labels.icon",
                                    stylers: [
                                          {
                                                visibility: "off",
                                          },
                                    ],
                              },
                              {
                                    featureType: "transit",
                                    stylers: [
                                          {
                                                visibility: "off",
                                          },
                                    ],
                              },
                        ],
                  },
                  selectedIndex: -1,
                  selectedIndex2: -1,
                  productService: null,
                  filters: {},
                  breadcrumbHome: {},
                  breadcrumbItems: [],
                  selectButtonValue1: null,
                  // selectButtonValues1: [
                  //       { name: "All", code: "O1" },
                  //       { name: "Stopped", code: "O2" },
                  //       { name: "Moving", code: "O3" },
                  //       { name: "Low Network", code: "O4" },
                  //       { name: "Disconnected", code: "O5" },
                  // ],
                  selectButtonValues1: [
                        { name: "Total Homes", code: "1", constant: true },
                        { name: "Visited", code: "2" },
                        { name: "Pending", code: "3" },
                  ],
                  routeitem_multiselect: "",
                  routeitems: [],
                  vehicle_dropdownItems: [],
                  vehicle_dropdownItem: "",
                  client_id_dropdown: [],
                  client_id_search: "",
                  vehicle_from_date: "",
                  vehicle_to_date: "",
                  vehicle_data: [],
                  search_vehicle_data: [],
                  splitterpanel: true,
                  reg_number: "",
                  list_loader: false,
                  polyline_show: true,
                  center: { lat: 19.0626704, lng: 73.005094 },
                  center1: {},
                  markers: [],
                  live_polypath: [],
                  polypath: {},
                  isLoadingModel: false,
                  fullPage: true,
                  total_stops: 0,
                  visited: 0,
                  original_home_list: [],
                  home_list: [],
                  original_marker_data: [],
                  home_productDialog: false,
                  tbl_name: "",
                  showFirstFilter: false,
                  district_dropdownItems: [],
                  district_dropdownItem: null,
                  block_dropdownItems: [],
                  block_dropdownItem: null,
                  village_dropdownItems: [],
                  village_dropdownItem: null,
                  ward_dropdownItems: [],
                  ward_dropdownItem: null,
                  speed_marker: [],
                  original_speed_marker: [],
                  checked: false,
            };
      },
      components: {
            GoogleMap,
            Marker,
            MarkerCluster,
            InfoWindow,
            Polyline,
            GoogleMapComponent,
            JsonExcel,
            //DashboardComponent
      },
      mounted() { },
      created() {
            this.productService = new ProductService();
            this.initFilters();
            this.get_dashboard_vehicle_list(3);
            this.getDistrictData();
            this.getBlockData();
            this.get_ward_master();
      },
      props: [
            "vehicle_dropdownItems",
            "routeitems",
            "client_id_dropdown",
            "user_key",
            "client_group_ids",
      ],
      methods: {
            updateSelectedValue() {
                  var data = this.car_data;
                  this.car_marker = data[this.selectedOption];
            },
            async exportCSV2() {
                  var excel_data = [];
                  var i = 1;
                  for (let index = 0; index < this.vehicle_data.length; index++) {
                        var json = [];
                        json = {
                              sr_no: i,
                              vehicle_number: this.vehicle_data[index].vehicle_number,
                              vehicle_type: this.vehicle_data[index].vehicle_type,
                              date: this.vehicle_data[index].date,
                              "Ride Duration (hrs)":
                                    this.vehicle_data[index]["Ride Duration (hrs)"],
                              "Distance Travelled (km)": this.vehicle_data[index][
                                    "Distance Travelled (km)"
                              ]
                                    ? this.vehicle_data[index]["Distance Travelled (km)"].toFixed(2)
                                    : 0,
                              "Routes Covered": this.vehicle_data[index]["Routes Covered"],
                              vehicle_number: this.vehicle_data[index].vehicle_number,
                        };
                        excel_data[index] = json;
                        i = i + 1;
                  }
                  const jsonData = excel_data;
                  const csvContent = this.convertJSONToCSV(jsonData);
                  const blob = new Blob([csvContent], { type: "text/csv" });
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.style.display = "none";
                  a.href = url;
                  a.download = "exported_data.csv";
                  document.body.appendChild(a);
                  a.click();
                  window.URL.revokeObjectURL(url);
                  document.body.removeChild(a);
            },
            convertJSONToCSV(jsonData) {
                  const delimiter = ","; // You can change the delimiter as needed
                  const keys = Object.keys(jsonData[0]);
                  const headerRow = keys.join(delimiter) + "\n";
                  const dataRows = jsonData
                        .map((row) => {
                              return keys
                                    .map((key) => {
                                          return row[key];
                                    })
                                    .join(delimiter);
                        })
                        .join("\n");
                  return headerRow + dataRows;
            },
            get_ward_master: function () {
                  var client_group_ids = [];
                  if (localStorage.getItem("client_group_ids")) {
                        client_group_ids = JSON.parse(localStorage.getItem("client_group_ids"));
                  } else {
                        client_group_ids.push(localStorage.getItem("client_id"));
                  }
                  if (this.client_id_search && this.client_id_search.length > 0) {
                        client_group_ids = [];
                        for (let x = 0; x < this.client_id_search.length; x++) {
                              client_group_ids.push(this.client_id_search[x].value);
                        }
                  }
                  var data = {
                        count: false,
                        client_id: this.client_id_search.value
                              ? this.client_id_search.value
                              : localStorage.getItem("client_id"),
                        client_group_ids: client_group_ids,
                        //   "district_id": this.district_dropdownItem.value,
                        //   "block_id": this.block_dropdownItem.value,
                        //   "village_id": this.village_dropdownItem.value,
                  };
                  var promise = apis.WardMaster(data, this.id);
                  promise.then((response) => {
                        this.ward_dropdownItems = [];
                        if (response.data.data.length > 0) {
                              var response_data = response.data.data;
                              for (let x = 0; x < response_data.length; x++) {
                                    this.ward_dropdownItems.push({
                                          name: response_data[x].name,
                                          value: response_data[x].name,
                                    });
                              }
                        }
                  });
            },
            async exportCSV() {
                  await this.$refs.home_dt.exportCSV();
            },
            async view_home_list(flag, data) {
               
                  var data_details = { _id: data.ride_id };
                  var promise = apis.getRideGroupStopData(data_details);
                  promise.then((response) => {
                        var data = response.data.data;
                        this.home_list = [];
                     
                        
                        for (let A = 0; A < data.length; A++) {
                              data[A]["distance"] = this.getDistanceFromLatLonInMeters(data[A]);
                        }
                        if (flag == 1) {
                              this.home_list = data.filter((item) => item.visit === "visited");
                              this.tbl_name = "Visited";
                        } else if (flag == 2) {
                              this.home_list = data.filter((item) => item.visit === "pending");
                              this.tbl_name = "Pending";
                        } else {
                              this.tbl_name = "";
                              this.home_list = data;
                        }
                        this.home_productDialog = true;
                  });
            },
            //------------------------------------------------------------------------------------------------------------------
            getDistrictData() {
                  var client_id = this.client_id_search.code
                        ? this.client_id_search.code
                        : localStorage.getItem("client_id");
                  this.loading = true;
                  var data = {
                        client_id: client_id,
                        count: false,
                  };
                  var promise = apis.getStateData(data);
                  promise.then((response) => {
                        this.loading = false;
                        if (response.data.data) {
                              var temp_data = [];
                              for (let x = 0; x < response.data.data.length; x++) {
                                    temp_data.push({
                                          name: response.data.data[x].name,
                                          value: response.data.data[x].code,
                                    });
                              }
                              this.district_dropdownItem = null;
                              this.district_dropdownItems = temp_data;
                              if (
                                    this.district_dropdownItems.length > 0 &&
                                    localStorage.getItem("district_id")
                              ) {
                                    var data = this.district_dropdownItems;
                                    var temp_district_id = this.string_to_array_converter(
                                          localStorage.getItem("district_id")
                                    );
                                    const valuesFromArr1 = new Set(temp_district_id);
                                    const filteredArr2 = data.filter((obj) =>
                                          valuesFromArr1.has(obj.value)
                                    );
                                    this.district_dropdownItems = filteredArr2;
                              }
                        }
                  });
            },
            getBlockData() {
                  this.block_dropdownItem = null;
                  this.block_dropdownItems = [];
                  var district_code = [];
                  if (this.district_dropdownItem) {
                        for (var d = 0; d < this.district_dropdownItem.length; d++) {
                              district_code.push(this.district_dropdownItem[d].value);
                        }
                  }
                  this.set_loading = true;
                  var data = {
                        district_code: district_code,
                        count: false,
                  };
                  var promise = apis.getBlockData(data);
                  promise.then((response) => {
                        this.set_loading = false;
                        if (response.data.data) {
                              var temp_data = [];
                              for (let x = 0; x < response.data.data.length; x++) {
                                    temp_data.push({
                                          name: response.data.data[x].name,
                                          value: response.data.data[x].code,
                                    });
                              }
                              this.block_dropdownItem = null;
                              this.block_dropdownItems = temp_data;
                              if (
                                    this.block_dropdownItems.length > 0 &&
                                    localStorage.getItem("block_id")
                              ) {
                                    var data = this.block_dropdownItems;
                                    var temp_block_id = this.string_to_array_converter(
                                          localStorage.getItem("block_id")
                                    );
                                    const valuesFromArr1 = new Set(temp_block_id);
                                    const filteredArr2 = data.filter((obj) =>
                                          valuesFromArr1.has(obj.value)
                                    );
                                    this.block_dropdownItems = filteredArr2;
                              }
                        }
                  });
            },
            getVillageData() {
                  var client_id = this.client_id_search.code
                        ? this.client_id_search.code
                        : localStorage.getItem("client_id");
                  this.loading = true;
                  var data = {
                        //client_id: client_id,
                        count: false,
                        service_name: "",
                        limit: "",
                        page_no: "",
                  };
                  var promise = apis.getVillageData(data);
                  promise.then((response) => {
                        this.loading = false;
                        if (response.data.data) {
                              var temp_data = [];
                              for (let x = 0; x < response.data.data.length; x++) {
                                    temp_data.push({
                                          name: response.data.data[x].village_name,
                                          value: response.data.data[x].code,
                                    });
                              }
                              this.village_dropdownItem = null;
                              this.village_dropdownItems = temp_data;
                        }
                  });
            },
            //------------------------------------------------------------------------------------------------------------------
            show_filter() {
                  this.showFirstFilter = true;
            },
            reset() {
                  this.showFirstFilter = false;
                  this.vehicle_data = [];
                  this.search_vehicle_data = [];
                  this.vehicle_from_date = "";
                  this.vehicle_to_date = "";
                  this.client_id_search = "";
                  this.vehicle_dropdownItem = "";
                  this.routeitem_multiselect = "";
                  this.reg_number = "";
                  this.ward_dropdownItem = null;
                  this.village_dropdownItem = null;
                  this.block_dropdownItem = null;
                  this.district_dropdownItem = null;
                  this.selectButtonValues1 = [
                        { name: "Total Homes", code: "1", constant: true },
                        { name: "Visited", code: "2" },
                        { name: "Pending", code: "3" },
                  ];
                  this.markers = [];
                  this.vehicle_data = [];
                  this.search_vehicle_data = [];
                  this.get_dashboard_vehicle_list(3);
            },
            initFilters() {
                  this.filters = {
                        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                  };
            },
            dateFormatYMD(inputDate) {
                  var postdate = inputDate;
                  if (inputDate) {
                        inputDate = new Date(inputDate);
                        if (inputDate.toString() == "NaN-NaN-NaN") {
                              return postdate;
                        } else {
                              let date = ("0" + inputDate.getDate()).slice(-2);
                              let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                              let year = inputDate.getFullYear();
                              if (date.toString() == "aN") {
                                    return postdate;
                              } else {
                                    return year + "-" + month + "-" + date;
                              }
                        }
                  } else {
                        return "";
                  }
            },
            dateFormatDMY(inputDate) {
                  var postdate = inputDate;
                  if (inputDate) {
                        inputDate = new Date(inputDate);
                        if (inputDate.toString() == "NaN-NaN-NaN") {
                              return postdate;
                        } else {
                              let date = ("0" + inputDate.getDate()).slice(-2);
                              let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                              let year = inputDate.getFullYear();
                              if (date.toString() == "aN") {
                                    return postdate;
                              } else {
                                    return date + "/" + month + "/" + year;
                              }
                        }
                  } else {
                        return "";
                  }
            },
            getFirstAndLastDateOfCurrentMonth() {
                  const currentDate = new Date();
                  const year = currentDate.getFullYear();
                  const month = currentDate.getMonth();
                  // Calculate the last day of the current month
                  const lastDay = new Date(year, month + 1, 0).getDate();
                  const firstDate = new Date(year, month, 1);
                  const lastDate = new Date(year, month, lastDay);
                  const formattedFirstDate = `${year}-${(month + 1)
                        .toString()
                        .padStart(2, "0")}-01`;
                  const formattedLastDate = `${year}-${(month + 1)
                        .toString()
                        .padStart(2, "0")}-${lastDay.toString().padStart(2, "0")}`;
                  return {
                        firstDate: formattedFirstDate,
                        lastDate: formattedLastDate,
                  };
            },
            string_to_array_converter(str) {
                  if (str) {
                        var substrings = str.split(",");
                        var strArray = substrings.map(function (substring) {
                              return parseFloat(substring.trim());
                        });
                        return strArray;
                  } else {
                        return [];
                  }
            },
            get_village(search) {
                  var district_code = [];
                  var block_code = [];
                  if (this.district_dropdownItem) {
                        for (var d = 0; d < this.district_dropdownItem.length; d++) {
                              district_code.push(this.district_dropdownItem[d].value);
                        }
                  }
                  if (this.block_dropdownItem) {
                        for (var c = 0; c < this.block_dropdownItem.length; c++) {
                              block_code.push(this.block_dropdownItem[c].value);
                        }
                  }
                  var data = {
                        count: false,
                        page_no: 1,
                        limit: 10,
                        search_name: search.value,
                        district_code: district_code,
                        block_code: block_code,
                  };
                  var promise = apis.getVillageData(data);
                  promise.then((response) => {
                        this.village_dropdownItems = [];
                        var temp = response.data.data;
                        for (let a = 0; a < temp.length; a++) {
                              this.village_dropdownItems.push({
                                    name: temp[a].village_name,
                                    value: temp[a].village_code,
                              });
                        }
                  });
            },
            get_dashboard_vehicle_list(flag) {
                  var from_date = "";
                  var to_date = "";
                  if (flag == 2) {
                        from_date = this.dateFormatYMD(this.vehicle_from_date[0]);
                        to_date = this.dateFormatYMD(this.vehicle_from_date[1]);
                  } else {
                        const { firstDate, lastDate } =
                              this.getFirstAndLastDateOfCurrentMonth();
                        this.vehicle_from_date = [new Date(firstDate), new Date(lastDate)];
                        from_date = firstDate;
                        to_date = lastDate;
                  }
                  var client_group_ids = [];
                  if (localStorage.getItem("client_group_ids")) {
                        client_group_ids = JSON.parse(localStorage.getItem("client_group_ids"));
                  } else {
                        client_group_ids.push(localStorage.getItem("client_id"));
                  }
                  if (this.client_id_search && this.client_id_search.length > 0) {
                        client_group_ids = [];
                        for (let x = 0; x < this.client_id_search.length; x++) {
                              client_group_ids.push(this.client_id_search[x].value);
                        }
                  }
                  var vehicle_type = [];
                  if (this.vehicle_dropdownItem && this.vehicle_dropdownItem.length > 0) {
                        for (let x = 0; x < this.vehicle_dropdownItem.length; x++) {
                              vehicle_type.push(this.vehicle_dropdownItem[x].value);
                        }
                  }
                  var routeitem_multiselect_type = [];
                  if (this.routeitem_multiselect && this.routeitem_multiselect.length > 0) {
                        for (let x = 0; x < this.routeitem_multiselect.length; x++) {
                              routeitem_multiselect_type.push(this.routeitem_multiselect[x].value);
                        }
                  }
                  var block_code = [];
                  var district_code = [];
                  var village_code = [];
                  var ward_code = [];
                  if (this.block_dropdownItem) {
                        for (var c = 0; c < this.block_dropdownItem.length; c++) {
                              block_code.push(this.block_dropdownItem[c].value);
                        }
                  }
                  if (this.district_dropdownItem) {
                        for (var d = 0; d < this.district_dropdownItem.length; d++) {
                              district_code.push(this.district_dropdownItem[d].value);
                        }
                  }
                  if (this.village_dropdownItem) {
                        for (var e = 0; e < this.village_dropdownItem.length; e++) {
                              village_code.push(this.village_dropdownItem[e].value);
                        }
                  }
                  if (this.ward_dropdownItem) {
                        for (var f = 0; f < this.ward_dropdownItem.length; f++) {
                              ward_code.push(this.ward_dropdownItem[f].value);
                        }
                  }
                  var data = {
                        count: false,
                        // "client_id":client_id,
                        client_group_ids: client_group_ids,
                        //"from_date": from_date,
                        //"to_date": to_date,
                        from_date: from_date,
                        to_date: to_date,
                        state_code: this.string_to_array_converter(
                              localStorage.getItem("state_code")
                        ),
                        // "district_id": this.string_to_array_converter(localStorage.getItem('district_id')),
                        // "block_id": this.string_to_array_converter(localStorage.getItem('block_id')),
                        // "village_id": this.string_to_array_converter(localStorage.getItem('village_id')),
                        vehicle_number: this.reg_number,
                        vehicle_type: vehicle_type,
                        route_id: routeitem_multiselect_type,

                        district_id: district_code,
                        block_id: block_code,
                        village_id: village_code,
                        ward_code: ward_code,
                  };
                  this.isLoadingModel = true;
                  var promise = apis.vehiclelistDashboard(data, this.id);
                  promise.then((response) => {
                        this.isLoadingModel = false;
                        this.vehicle_data = [];
                        this.search_vehicle_data = [];
                        this.vehicle_data = response.data.data;
                        if (this.vehicle_data.length > 0) {
                              this.splitterpanel = true;
                              this.vehicle_data.forEach((vehicle, index) => {
                                    vehicle["sr_no"] = Math.random();
                              });
                              if (flag == 3 || flag == 2) {
                                    this.get_select_vehicle_details(this.vehicle_data[0], 1, 0);
                              }
                        } else {
                              this.splitterpanel = false;
                        }
                  });
            },
            close() {
                  this.splitterpanel = false;
            },
            getDistanceFromLatLonInMeters(data) {
                  var lat1 = data.visit_lat;
                  var lon1 = data.visit_lng;
                  var lat2 = data.stop_location.lat;
                  var lon2 = data.stop_location.lng;
                  if (data.visit_lat == 0 || data.visit_lng == 0) {
                        return "0";
                  }
                  const earthRadius = 6371000; // Earth's radius in meters
                  const deg2rad = (deg) => {
                        return deg * (Math.PI / 180);
                  };
                  const dLat = deg2rad(lat2 - lat1);
                  const dLon = deg2rad(lon2 - lon1);
                  const a =
                        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(deg2rad(lat1)) *
                        Math.cos(deg2rad(lat2)) *
                        Math.sin(dLon / 2) *
                        Math.sin(dLon / 2);
                  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                  const distance = earthRadius * c;
                  return distance.toFixed(2);
            },
            async getRideGroupStopData(id) {
                  var data = { _id: id };
                  var promise = apis.getRideGroupStopData(data);
                  promise.then((response) => {
                        if (response.data.data) {                             
                              var list = response.data.data;
                              for (let A = 0; A < list.length; A++) {
                                    list[A]["distance"] = this.getDistanceFromLatLonInMeters(list[A]);
                              }
                              //this.home_list = list;
                              this.original_home_list = list;
                              this.visited = 0;
                              this.total_stops = 0;
                              var stops_data = [];
                              this.total_stops = response.data.data.length;
                              for (let x = 0; x < response.data.data.length; x++) {
                                    var icon = "";
                                    if (response.data.data[x].status == "visited") {
                                          this.visited = this.visited + 1;
                                          icon = "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
                                    } else {
                                          icon = "http://maps.google.com/mapfiles/ms/icons/red-dot.png";
                                    }
                                    stops_data.push({
                                          lat: parseFloat(response.data.data[x].stop_location.lat),
                                          lng: parseFloat(response.data.data[x].stop_location.lng),
                                          stop_name: response.data.data[x].stop_name,
                                          icon: icon,
                                          status: response.data.data[x].status,
                                    });
                              }
                              var total_homes = "All Homes" + " (" + this.total_stops + ")";
                              var visited = "Visited" + " (" + this.visited + ")";
                              var Total_pending = this.total_stops - this.visited;
                              var Pending = "Pending" + " (" + Total_pending + ")";
                              this.selectButtonValues1 = [
                                    { name: total_homes, code: "1", constant: true },
                                    { name: visited, code: "2" },
                                    { name: Pending, code: "3" },
                              ];
                              this.selectButtonValue1 = [
                                    { name: visited, code: "2" },
                                    { name: Pending, code: "3" },
                              ];
                              this.markers = stops_data;
                              this.original_marker_data = stops_data;
                        }
                  });
            },
            async getRideData(id, flag) {
                  var data = { ride_id: id, speed: true };
                  var promise = "";
                  this.list_loader = true;
                  if (flag == 1) {
                        promise = apis.getRideDataLive(data);
                  } else if (flag == 2) {
                        promise = apis.get_RideDataHistory(data);
                  } else {
                        return false;
                  }
                  promise.then((response) => {
                        this.list_loader = false;
                        this.list = [];
                        var speed_exceed = [];
                        this.list = response.data.data;
                  
                        speed_exceed = response.data.speed_exceed;
                        if (speed_exceed.length > 0) {
                              var speed_data = [];
                              for (let x = 0; x < speed_exceed.length; x++) {
                                    if (
                                          speed_exceed[x].lat &&
                                          speed_exceed[x].lng &&
                                          speed_exceed[x].speed > 1
                                    ) {
                                          speed_data.push({
                                                lat: parseFloat(speed_exceed[x].lat),
                                                lng: parseFloat(speed_exceed[x].lng),
                                          });
                                    }
                              }
                              this.speed_marker = speed_data;
                              this.original_speed_marker = speed_data;
                              this.checked = true;
                        }
                        if (flag == 1 && this.list.length == 0) {
                              this.getRideData(id, 2);
                              return false;
                        }
                        if (this.list.length > 0) {
                              if (flag == 1) {
                                    this.total_distance=response.data.distance;
                                    this.total_time=response.data.ride_time;
                                    var length = this.list.length;
                                    this.center = {
                                          lat: parseFloat(this.list[0].lat),
                                          lng: parseFloat(this.list[0].lng),
                                    };
                                    this.car_marker = {
                                          lat: parseFloat(this.list[0].lat),
                                          lng: parseFloat(this.list[0].lng),
                                    };
                                    //this.center1 = { lat: parseFloat(this.list[length - 1].lat), lng: parseFloat(this.list[length - 1].lng) };
                                    var data = [];
                                    for (let x = 0; x < length; x++) {
                                          if (this.list[x].lat && this.list[x].lng) {
                                                data.push({
                                                      lat: parseFloat(this.list[x].lat),
                                                      lng: parseFloat(this.list[x].lng),
                                                });
                                          }
                                    }
                                    //this.polypath = {path:data}
                                    this.car_data = [];
                                    this.car_data = data;
                                    this.polypath = {
                                          path: data,
                                          geodesic: true,
                                          strokeColor: "blue",
                                          strokeOpacity: 0.5,
                                          strokeWeight: 5,
                                    };
                              } else if (flag == 2) {
                                    var vehicle_length = this.list.length;
                                    this.center = {
                                          lat: parseFloat(this.list[0].lat),
                                          lng: parseFloat(this.list[0].lng),
                                    };
                                    this.car_marker = {
                                          lat: parseFloat(this.list[0].lat),
                                          lng: parseFloat(this.list[0].lng),
                                    };
                                    this.center1 = {
                                          lat: parseFloat(this.list[vehicle_length - 1].lat),
                                          lng: parseFloat(this.list[vehicle_length - 1].lng),
                                    };
                                    var vehicle_map_data = [];
                                    for (let x = 0; x < vehicle_length; x++) {
                                          if (this.list[x].lat && this.list[x].lng) {
                                                vehicle_map_data.push({
                                                      lat: parseFloat(this.list[x].lat),
                                                      lng: parseFloat(this.list[x].lng),
                                                });
                                          }
                                    }
                                    //this.polypath = {path:vehicle_map_data}
                                    this.car_data = [];
                                    this.car_data = vehicle_map_data;
                                    this.polypath = {
                                          path: vehicle_map_data,
                                          geodesic: true,
                                          strokeColor: "blue",
                                          strokeOpacity: 0.5,
                                          strokeWeight: 5,
                                    };
                              }
                        }
                  });
            },
            async view_Map(data) {
                  //await this.getRideMaster(data.ride_id);
                  await this.getRideGroupStopData(data.ride_id);
                  await this.getRideData(data.ride_id, 2);
                  this.visited = 0;
                  this.total_stops = 0;
                  this.pending = true;
                  this.visit = true;
                  this.route_name = data.route_name;
                  //   this.map_productDialog = true;
            },
            selectCard(data, index) {
                  this.selectedIndex2 = index;
                  this.view_Map(data);
            },
            get_select_vehicle_details(event, flag, index) {
                  this.splitterpanel = true;
                  if (index || index == 0) {
                        this.selectedIndex = index;
                        this.selectedIndex2 = index;
                  }
                  var client_group_ids = [];
                  if (localStorage.getItem("client_group_ids")) {
                        client_group_ids = JSON.parse(localStorage.getItem("client_group_ids"));
                  } else {
                        client_group_ids.push(localStorage.getItem("client_id"));
                  }
                  //var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
                  // var client_id = localStorage.getItem('client_id') ? localStorage.getItem('client_id'):[];
                  if (this.client_id_search && this.client_id_search.length > 0) {
                        client_group_ids = [];
                        for (let x = 0; x < this.client_id_search.length; x++) {
                              client_group_ids.push(this.client_id_search[x].value);
                        }
                  }
                  var vehicle_type = [];
                  if (this.vehicle_dropdownItem && this.vehicle_dropdownItem.length > 0) {
                        for (let x = 0; x < this.vehicle_dropdownItem.length; x++) {
                              vehicle_type.push(this.vehicle_dropdownItem[x].value);
                        }
                  }
                  var routeitem_multiselect_type = [];
                  if (this.routeitem_multiselect && this.routeitem_multiselect.length > 0) {
                        for (let x = 0; x < this.routeitem_multiselect.length; x++) {
                              routeitem_multiselect_type.push(this.routeitem_multiselect[x].value);
                        }
                  }
                  var block_code = [];
                  var district_code = [];
                  var village_code = [];
                  var ward_code = [];
                  if (this.block_dropdownItem) {
                        for (var c = 0; c < this.block_dropdownItem.length; c++) {
                              block_code.push(this.block_dropdownItem[c].value);
                        }
                  }
                  if (this.district_dropdownItem) {
                        for (var d = 0; d < this.district_dropdownItem.length; d++) {
                              district_code.push(this.district_dropdownItem[d].value);
                        }
                  }
                  if (this.village_dropdownItem) {
                        for (var e = 0; e < this.village_dropdownItem.length; e++) {
                              village_code.push(this.village_dropdownItem[e].value);
                        }
                  }
                  if (this.ward_dropdownItem) {
                        for (var f = 0; f < this.ward_dropdownItem.length; f++) {
                              ward_code.push(this.ward_dropdownItem[f].value);
                        }
                  }
                  var data = {
                        count: false,
                        client_group_ids: client_group_ids,
                        //"client_id":client_id,
                        date: event.date,
                        vehicle_id: event.vehicle_id,
                        state_code: this.string_to_array_converter(
                              localStorage.getItem("state_code")
                        ),
                        // "district_id": this.string_to_array_converter(localStorage.getItem('district_id')),
                        // "block_id": this.string_to_array_converter(localStorage.getItem('block_id')),
                        // "village_id": this.string_to_array_converter(localStorage.getItem('village_id')),
                        vehicle_number: this.reg_number,
                        vehicle_type: vehicle_type,
                        route_id: routeitem_multiselect_type,

                        district_id: district_code,
                        block_id: block_code,
                        village_id: village_code,
                        ward_code: ward_code,
                  };
                  this.isLoadingModel = true;
                  var promise = apis.vehicleRideList(data, this.id);
                  promise.then((response) => {
                        this.isLoadingModel = false;
                        this.search_vehicle_data = response.data.data;
                        if (flag && flag == 1 && this.search_vehicle_data.length > 0) {
                              this.view_Map(this.search_vehicle_data[0]);
                              this.selectedIndex2 = 0;
                        }
                  });
            },
      },
      watch: {
            checked: function (val) {
                  if (val == true) {
                        this.speed_marker = this.original_speed_marker;
                  } else {
                        this.speed_marker = [];
                  }
            },
            selectButtonValue1: function (val) {
                  if (this.selectButtonValue1.length == 2) {
                        this.markers = this.original_marker_data;
                  } else if (this.selectButtonValue1.length == 1) {
                        var stop_data = [];
                        var data = this.original_marker_data;
                        for (let z = 0; z < data.length; z++) {
                              if (
                                    this.selectButtonValue1[0].code == 2 &&
                                    data[z].status == "visited"
                              ) {
                                    stop_data.push(data[z]);
                              }
                              if (
                                    this.selectButtonValue1[0].code == 3 &&
                                    data[z].status == "pending"
                              ) {
                                    stop_data.push(data[z]);
                              }
                        }
                        this.markers = stop_data;
                  } else {
                        this.markers = [];
                  }
            },
            visit: function (val) {
                  var stop_data = [];
                  var data = this.original_marker_data;
                  for (let z = 0; z < data.length; z++) {
                        if (this.visit == true && data[z].status == "visited") {
                              stop_data.push(data[z]);
                        }
                        if (this.pending == true && data[z].status == "pending") {
                              stop_data.push(data[z]);
                        }
                  }
                  this.markers = stop_data;
            },
            pending: function (val) {
                  var stop_data = [];
                  var data = this.original_marker_data;
                  for (let z = 0; z < data.length; z++) {
                        if (this.visit == true && data[z].status == "visited") {
                              stop_data.push(data[z]);
                        }
                        if (this.pending == true && data[z].status == "pending") {
                              stop_data.push(data[z]);
                        }
                  }
                  this.markers = stop_data;
            },
            live_polypath: function (val) {
                  this.hide(1);
                  setTimeout(
                        function () {
                              this.hide(2);
                        }.bind(this),
                        50
                  );
            },
            polyline() {
                  alert("ok");
                  this.home = true;
                  this.home = false;
            },
      },
};
</script>
<style lang="scss" scoped>
.selected {
      background-color: #eff3f8;
      border-style: solid;
      border-color: green;
      box-shadow: 2px 2px 5px green;
      /* Change this to your desired highlight color */
}

.selected2 {
      background-color: #eff3f8;
      border-style: solid;
      border-color: green;
      /* Change this to your desired highlight color */
}

.gps_header_container {
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      position: relative;
      z-index: 1;
}
::v-deep .p-button.p-highlight {
  /* Change the background color and text color for selected options */
  background-color: #28a745; /* Set the desired background color for selected options */
  color: #fff; /* Set the desired text color for selected options */
}
/* Hover styles for selected options */
::v-deep .p-button.p-highlight:hover {
  background-color: #28a745; /* Set the hover background color for selected options */
  color: #fff; /* Set the hover text color for selected options */
}
</style>
